import Form from "../../components/Form";
import {useForm} from "react-hook-form";
import InputWrapper from "../../../components/InputWrapper";
import {useParams} from "react-router-dom";
import {useState} from "react";
import Error from "../../components/Error";
import moment from "moment";
import Data from "../../../Data";

const One = () => {
    const { id } = useParams();

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false);
    const [eventsCreated, setEventsCreated] = useState(0);

    const { register, handleSubmit, formState: { errors }, control } = useForm()

    const submit = async ({ date }) => {
        setEventsCreated(0)

        const dates = [new Date(date)];

        if(window.confirm(`Your are about to create the following events:\n${dates.map(date => `\n${moment(date).format('ddd Do MMM YY HH:mm A')}`)} \n\nAre you sure?`)){
            try {
                setLoading(true)
                await Data.createEvents({ experienceId: id, dates: dates })
                setEventsCreated(dates.length)
                setError(false)
            } catch(error){
                setError(true)
            } finally {
                setLoading(false)
            }
        }
    }

    return (
        <Form heading={"One"} onSubmit={handleSubmit(submit)}>
            <p className={"text-textGrey"}>Add a single event for a specific date and time.</p>
            <InputWrapper label={'Date and Time'} input={<input type={'datetime-local'} {...register('date', { required: true })} />} error={errors.startDate ? 'This field is required' : null} />
            <div className={"flex items-center gap-4"}>
                <button
                    disabled={loading}
                    className={"bg-backgroundGrey border px-2.5 py-1.5 rounded-md hover:opacity-80 transition"}>{loading ? 'Creating Events...' : 'Create'}
                </button>
                {eventsCreated ? <p className={"text-green-600"}>{eventsCreated} Event{eventsCreated > 1 ? 's' : ''} Created</p> : null}
            </div>
            {error ? <Error message={"An error occurred, please try again"} /> : null }
        </Form>
    )
}

export default One